import React from "react";
import Text from "../text/Text";
export const splitSuggestionToHighlight = (suggestion, filter) => {
    const search = suggestion.search(filter);
    if (search === -1) {
        return [suggestion];
    }
    const split = [
        suggestion.substring(0, search),
        suggestion.substring(search, search + filter.source.length),
        suggestion.substring(search + filter.source.length),
    ];
    return split.filter((s) => s !== "");
};
export const highlightSuggestion = (suggestion, filter) => {
    const unsplit = React.createElement(Text, { onMouseDown: (e) => e.preventDefault() }, suggestion);
    if (filter === "") {
        return unsplit;
    }
    let filterPattern;
    try {
        filterPattern = new RegExp(`${filter}`, "i");
    }
    catch (_a) {
        return unsplit;
    }
    const split = splitSuggestionToHighlight(suggestion, filterPattern);
    let highlighted = false;
    return split.map((s, i) => {
        if (!highlighted && filterPattern.test(s)) {
            highlighted = true; // only highlight the first matching pattern
            return (React.createElement(Text, { key: i, onMouseDown: (e) => e.preventDefault(), variant: "bodyStrong" }, s));
        }
        else {
            return (React.createElement(Text, { onMouseDown: (e) => e.preventDefault(), key: i }, s));
        }
    });
};
//# sourceMappingURL=highlighting.js.map